import { useContext, useEffect } from "react";
import { FullScreen } from "ol/control";
import RMMSContext from "../../context/RMMSContext";
const FullScreenControl = () => {
  const { map } = useContext(RMMSContext);
  useEffect(() => {
    if (!map) return;
    let fullScreenControl = new FullScreen({});
    map.controls.push(fullScreenControl);

    return () => map.controls.remove(fullScreenControl);
  }, [map]);
  return null;
};
export default FullScreenControl;